<template>
    <div class="exam_paper">
        <div class="exam_paper_top flex flexcolumn Flexalign">
            <div class="top_content flex FlexBetween Flexalign">
                <div class="exam_name">{{ paperInfo.testName }}</div>
                <div class="flex Flexalign">
                    <el-progress :percentage="(examProgress / examTotal) * 100" color="#13D6AA"
                        :format="formatProgressLabel" style="width: 280px;height: 10px;"></el-progress>
                    <div class="ml-15"><span class="text_active">{{ examProgress }}</span>/{{ examTotal }}</div>
                    <div class="ml-15">完成题数</div>
                    <!-- 添加切屏次数显示 -->
                    <!-- <div class="ml-15" v-if="exitFullscreenCount > 0">
                        <span style="color: #ff4d4f;">切屏次数: {{ exitFullscreenCount }}</span>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="exam_content flex Flexalign Flexjustify">
            <div class="exam_content_box mt-30 flex FlexBetween">
                <div class="test_paper_practice">
                    <!-- <div class="flex Flexalign cursor_pointer back_box" @click="practiceBack">
                        <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
                        <div class="back_text">返回</div>
                    </div> -->
                    <testPaper :examInfo="examInfo" :hideCountDown="true" :hideBackBtn="true"
                        @refreshTextExam="refreshTextExam"></testPaper>
                </div>
                <examAnswerSheet ref="examAnswerSheet" @refreshTextExam="refreshTextExam" :showCourseOutline="false"
                    :examType="'practice'" :homeworkType="'afterHomework'" :countDown="countDown"
                    @exitFullScreen="exitFullScreenAction" :paperType="paperType"></examAnswerSheet>
            </div>
        </div>
        <examStartPrompty ref="examStartPrompty" @exam-started="handleExamStarted"></examStartPrompty>
        <examExistPrompty ref="examExistPrompty" :paperOtherRule="paperOtherRule"
            @return-fullscreen="handleReturnFullscreen" @force-submit="handleForceSubmit"></examExistPrompty>
    </div>
</template>

<script>
import testPaper from './components/testPaper.vue';
import examStartPrompty from '@/components/popup/examStartPrompty.vue';
import examExistPrompty from '@/components/popup/examExistPrompty.vue';
import examAnswerSheet from '@/components/exam/examAnswerSheet.vue';
import { mapState } from "vuex";

export default {
    name: 'GjkcH5ExamPaper',
    components: {
        testPaper,
        examStartPrompty,
        examExistPrompty,
        examAnswerSheet,
    },
    computed: {
        ...mapState({
            testExamInfo: (state) => state.exam.testExamInfo,
        }),
    },
    watch: {
        testExamInfo: {
            handler() {
                this.countFinish()
            },
            deep: true
        },
    },

    data() {
        return {
            examProgress: 0,
            examTotal: 6,
            paperInfo: '',
            examInfo: {},
            isBegin: false,
            exitFullscreenCount: 0, // 退出全屏次数
            isFullscreen: false, // 当前是否全屏
            fullscreenListener: null, // 全屏监听器
            checkFullscreenInterval: null, // 检查全屏状态的定时器
            countDown: 0,
            timerInterval: null,
            paperType: "",
            buyerUserId: '',
            paperOtherRule: {},
            isSubmitting: false, // 添加提交状态标志
            isExitingFullscreen: false, // 标记是否正在退出全屏
        };
    },

    mounted() {
        this.paperInfo = JSON.parse(this.$Jump.getUrlParams(window.location.hash.split("?")[1]).paperInfo);
        this.paperType = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).paperType;
        this.buyerUserId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).buyerUserId;
        if (this.paperType == 'testPaper') {
            this.getTestPaper();
        } else if (this.paperType == 'examination') {
            this.getExaminationPaper();
        } else {
            this.getPaperList();
        }
        if (this.paperType != 'examination') {
            // 初始化全屏监听
            this.initFullscreenListener();
        }
        if (this.paperInfo.otherRule) {
            this.paperOtherRule = JSON.parse(this.paperInfo.otherRule);
        }
    },

    beforeUnmount() {
        // 组件销毁前移除监听和定时器
        this.removeFullscreenListener();
        this.clearFullscreenCheckInterval();
        this.isExitingFullscreen = false; // 重置状态
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = "";
        }
    },

    methods: {
        practiceBack() {
            this.back()
        },
        // 统计已完成题目数量
        countFinish() {
            this.examProgress = 0;
            this.examTotal = 0;
            this.testExamInfo.paperContext.forEach((item) => {
                item.questions.forEach((sitem) => {
                    if (sitem.questionContext?.isFinish) {
                        this.examProgress++;
                    }
                    this.examTotal++;
                });
            });
        },
        formatProgressLabel() {
            return '';
        },
        getTestPaper() {
            this.$Api.testPaper.getTestPaper(this.paperInfo.paperId, this.buyerUserId).then(res => {
                this.examInfo = res.data.data;
                this.countDown = this.examInfo.answerTime * 60;
                this.$refs.examStartPrompty.examStartPromptyShow = true;
                this.examTotal = this.examInfo.questionCount;
            }).catch(() => { })
        },

        getPaperList() {
            this.$Api.exam.getPaperList(this.paperInfo.paperId).then(res => {
                this.examInfo = res.data.data;
                this.countDown = this.examInfo.answerTime * 60;
                this.$refs.examStartPrompty.examStartPromptyShow = true;
                this.examTotal = this.examInfo.questionCount;
                this.paperOtherRule = this.examInfo.otherRule;
            }).catch(() => { })
        },

        getExaminationPaper() {
            this.$Api.examination.getExamPaperInfo(this.paperInfo.paperId).then(res => {
                this.examInfo = res.data.data;
                this.countDown = this.examInfo.answerTime * 60;
                this.examTotal = this.examInfo.questionCount;
                this.paperOtherRule = this.examInfo.otherRule;
                // 考试开始定时器启动
                this.timerInterval = setInterval(() => {
                    this.countDown--;
                    // 考试时间到清除定时器
                    if (this.countDown <= 0) {
                        if (this.timerInterval) {
                            clearInterval(this.timerInterval);
                            this.timerInterval = "";
                        }
                    }
                }, 1000);
            }).catch(() => { })
        },

        // 初始化全屏状态监听
        initFullscreenListener() {
            // 监听全屏变化事件
            const fullscreenChange = () => {
                const isFullscreen = !!(
                    document.fullscreenElement ||
                    document.webkitFullscreenElement ||
                    document.mozFullScreenElement ||
                    document.msFullscreenElement
                );

                console.log('全屏状态变化:', isFullscreen ? '进入全屏' : '退出全屏');

                // 如果之前是全屏，现在退出全屏，则计数
                if (this.isFullscreen && !isFullscreen) {
                    this.handleExitFullscreen();
                }

                // 更新当前全屏状态
                this.isFullscreen = isFullscreen;
            };

            // 添加事件监听（兼容不同浏览器）
            document.addEventListener('fullscreenchange', fullscreenChange);
            document.addEventListener('webkitfullscreenchange', fullscreenChange);
            document.addEventListener('mozfullscreenchange', fullscreenChange);
            document.addEventListener('MSFullscreenChange', fullscreenChange);

            // 保存监听器引用以便后续移除
            this.fullscreenListener = fullscreenChange;
        },

        // 移除全屏监听
        removeFullscreenListener() {
            if (this.fullscreenListener) {
                document.removeEventListener('fullscreenchange', this.fullscreenListener);
                document.removeEventListener('webkitfullscreenchange', this.fullscreenListener);
                document.removeEventListener('mozfullscreenchange', this.fullscreenListener);
                document.removeEventListener('MSFullscreenChange', this.fullscreenListener);
            }
        },

        // 处理退出全屏事件
        handleExitFullscreen() {
            // 如果正在提交中，直接返回
            if (this.isSubmitting) {
                return;
            }

            // 只有在考试进行中才计数
            if (this.isBegin) {
                this.exitFullscreenCount++;
                console.log(`退出全屏次数: ${this.exitFullscreenCount}`);

                // 显示退出全屏提示弹窗
                this.showExitWarning();

                // 启动全屏状态检查
                this.startFullscreenCheck();
            }
        },

        // 显示退出全屏警告
        showExitWarning() {
            // 如果正在提交中，直接返回
            if (this.isSubmitting) {
                return;
            }

            // 更新弹窗的退出次数
            this.$refs.examExistPrompty.leaveNum = this.exitFullscreenCount;
            this.$refs.examExistPrompty.examExistPromptyShow = true;

            // 如果切屏次数达到限制，自动交卷
            if (this.exitFullscreenCount >= (this.paperOtherRule.pageSwitchLimit ? this.paperOtherRule.pageSwitchLimit : this.paperOtherRule.preventSwitchPageTimes)) {
                this.$refs.examExistPrompty.examExistPromptyShow = false;
                // if(this.paperOtherRule.pageSwitchLimit != 0){
                this.handleForceSubmit();
                // }
                // this.handleForceSubmit();
            }
        },

        // 开始检查全屏状态
        startFullscreenCheck() {
            // 清除之前的定时器
            this.clearFullscreenCheckInterval();

            // 每20秒检查一次是否回到全屏
            this.checkFullscreenInterval = setInterval(() => {
                const isFullscreen = !!(
                    document.fullscreenElement ||
                    document.webkitFullscreenElement ||
                    document.mozFullScreenElement ||
                    document.msFullscreenElement
                );

                if (isFullscreen) {
                    // 回到全屏，清除定时器
                    this.clearFullscreenCheckInterval();
                    this.$refs.examExistPrompty.examExistPromptyShow = false;
                } else {
                    // 仍然不在全屏状态，强制用户返回全屏
                    this.forceReturnFullscreen();
                }
            }, 20000);
        },

        // 清除全屏检查定时器
        clearFullscreenCheckInterval() {
            if (this.checkFullscreenInterval) {
                clearInterval(this.checkFullscreenInterval);
                this.checkFullscreenInterval = null;
            }
        },

        // 强制返回全屏
        forceReturnFullscreen() {
            if (this.isBegin && !this.isFullscreen) {
                console.log('强制返回全屏');
                this.enterFullscreen();
            }
        },

        // 进入全屏
        enterFullscreen() {
            let element = document.documentElement;
            if (element.requestFullscreen) {
                element.requestFullscreen().catch(err => {
                    console.error('进入全屏失败:', err);
                });
            } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        },

        // 处理强制交卷
        handleForceSubmit() {
            // 如果正在提交中，直接返回
            if (this.isSubmitting) {
                return;
            }

            console.log('因切屏次数过多，强制交卷');
            this.autoSubmitExam();
            // this.$Dialog.confirm({
            //     message: "切屏次数已达上限，系统将自动交卷",
            //     title: "警告", // 可选，不传则使用默认值'确认'
            //     onConfirm: () => {
            //         this.autoSubmitExam();
            //         // }
            //     }, // 确认后的操作，如调用删除API等
            //     onCancel: () => {
            //         this.autoSubmitExam();
            //     }, // 取消后的操作，可选不传则无动作。也可以在这里添加其他逻辑。
            // });
        },

        // 自动交卷
        autoSubmitExam() {
            // 设置提交状态，防止重复执行
            this.isSubmitting = true;
            this.isExitingFullscreen = false; // 确保退出状态重置

            console.log('自动交卷');
            this.isBegin = false;
            this.$refs.examExistPrompty.examExistPromptyShow = false;

            // 清除所有定时器
            // this.clearFullscreenCheckInterval();
            // 这里调用交卷的API
            // this.$Api.exam.submitExam(...)
            this.$refs.examAnswerSheet.commitPaper('violation'); // violation 是违规（切屏次数过多）
            // this.exitFullScreenAction();

            // 退出全屏
            // this.exitFullscreen();
        },
        // 处理提交试卷退出全屏
        async exitFullScreenAction(recordId, isWait) {
            console.log("=== exitFullScreenAction 开始 ===");
            console.log("recordId:", recordId);
            console.log("paperOtherRule:", this.paperOtherRule);
            console.log("paperType:", this.paperType);

            // 如果正在退出全屏，直接返回避免重复执行
            if (this.isExitingFullscreen) {
                console.log("正在退出全屏中，跳过重复执行");
                return;
            }

            // 设置退出状态
            this.isExitingFullscreen = true;

            // 立即检查所有条件，不等待任何异步操作
            const isEmpty = this.$Tools.empty(recordId);
            console.log("recordId 是否为空:", isEmpty);

            if (isEmpty) {
                console.log("由于 recordId 为空，直接返回");
                this.isExitingFullscreen = false; // 重置状态
                return;
            }

            console.log("直接执行跳转逻辑，跳过所有异步操作");
            console.log("paperOtherRule.subjectiveQuestionMarking:", this.paperOtherRule.subjectiveQuestionMarking);

            // 异步退出全屏，但不阻塞主流程
            this.exitFullscreenAsync().finally(() => {
                console.log("全屏退出流程完成");
                this.isExitingFullscreen = false; // 重置状态
            });
            // 此处加上逻辑（提交失败进入等待页面）
            if (isWait) {
                this.href('/examWaitResult', { recordId: recordId, testPaperType: this.paperType });
                return
            }

            // 此处判断是否需要批阅(subjectiveQuestionMarking为1无需批阅（系统批阅），直接跳转至考试结果页面，0需要批阅可向上返回两页)
            if (this.paperOtherRule.subjectiveQuestionMarking == 1) {
                console.log("条件满足: subjectiveQuestionMarking == 1");
                // 测评加上标识
                if (this.paperType == 'testPaper') {
                    console.log("跳转到 examFinish，paperType 为 testPaper");
                    this.href('/examFinish', { recordId: recordId, testPaperType: this.paperType });
                } else {
                    console.log("跳转到 examFinish，普通试卷");
                    this.href("/examRecordPaper", { recordId: recordId });
                }
            } else {
                console.log("条件不满足: subjectiveQuestionMarking != 1，返回上一页");
                this.href('/examFinish', { recordId: recordId, testPaperType: this.paperType });
            }

            console.log("=== exitFullScreenAction 结束 ===");
        },
        // 新增异步退出全屏方法（不阻塞主流程）
        exitFullscreenAsync() {
            return new Promise((resolve) => {
                console.log("开始异步退出全屏");

                // 设置超时，确保不会无限期等待
                const timeoutId = setTimeout(() => {
                    console.log("退出全屏超时，强制继续流程");
                    resolve();
                }, 3000);

                // 尝试退出全屏
                this.safeExitFullscreen().then(() => {
                    clearTimeout(timeoutId);
                    console.log("全屏退出成功");
                    resolve();
                }).catch((error) => {
                    clearTimeout(timeoutId);
                    console.log("全屏退出失败:", error);
                    resolve(); // 即使失败也继续流程
                });
            });
        },
        // 安全退出全屏方法
        safeExitFullscreen() {
            return new Promise((resolve) => {
                // 检查当前是否在全屏状态
                const isFullscreen = !!(
                    document.fullscreenElement ||
                    document.webkitFullscreenElement ||
                    document.mozFullScreenElement ||
                    document.msFullscreenElement
                );

                if (!isFullscreen) {
                    console.log("当前不在全屏状态，无需退出");
                    resolve();
                    return;
                }

                console.log("开始安全退出全屏");

                // 尝试所有可能的退出全屏方法
                const exitMethods = [
                    () => document.exitFullscreen?.(),
                    () => document.webkitExitFullscreen?.(),
                    () => document.mozCancelFullScreen?.(),
                    () => document.msExitFullscreen?.(),
                ];

                let exitAttempted = false;

                for (const method of exitMethods) {
                    try {
                        const result = method();
                        if (result && typeof result.then === 'function') {
                            exitAttempted = true;
                            result.then(() => {
                                console.log("全屏退出成功");
                                resolve();
                            }).catch((error) => {
                                console.log("全屏退出方法失败:", error);
                                // 继续尝试下一个方法
                            });
                            break;
                        }
                    } catch (e) {
                        console.log('退出全屏方法异常:', e);
                    }
                }

                // 如果没有任何方法被调用，直接resolve
                if (!exitAttempted) {
                    console.log("没有可用的全屏退出方法，直接继续流程");
                    resolve();
                }
            });
        },

        // 强制退出全屏
        forceExitFullscreen() {
            return new Promise((resolve) => {
                console.log("开始强制退出全屏");

                // 设置超时，确保无论如何在3秒后resolve
                const timeoutId = setTimeout(() => {
                    console.log("退出全屏超时，强制继续流程");
                    resolve();
                }, 3000);

                // 尝试所有可能的退出全屏方法
                const exitMethods = [
                    () => document.exitFullscreen?.(),
                    () => document.webkitExitFullscreen?.(),
                    () => document.mozCancelFullScreen?.(),
                    () => document.msExitFullscreen?.(),
                ];

                let exitAttempted = false;

                // 尝试每个退出方法
                for (const method of exitMethods) {
                    try {
                        const result = method();
                        if (result && typeof result.then === 'function') {
                            result.then(() => {
                                clearTimeout(timeoutId);
                                resolve();
                            }).catch(() => {
                                // 忽略错误，继续尝试下一个方法
                                clearTimeout(timeoutId);
                                if (!exitAttempted) {
                                    // 如果所有方法都失败，最后resolve
                                    setTimeout(resolve, 100);
                                }
                            });
                            exitAttempted = true;
                            break;
                        }
                    } catch (e) {
                        // 忽略错误，继续尝试下一个方法
                        console.log('退出全屏方法失败:', e);
                    }
                }

                // 如果没有任何方法被调用，直接resolve
                if (!exitAttempted) {
                    clearTimeout(timeoutId);
                    console.log("没有可用的全屏退出方法，直接继续流程");
                    resolve();
                }
            });
        },

        // 确保退出全屏
        ensureExitFullscreen() {
            return new Promise((resolve) => {
                const checkFullscreen = () => {
                    const isFullscreen = !!(
                        document.fullscreenElement ||
                        document.webkitFullscreenElement ||
                        document.mozFullScreenElement ||
                        document.msFullscreenElement
                    );

                    if (!isFullscreen) {
                        console.log("确认已退出全屏");
                        resolve();
                    } else {
                        console.log("仍在全屏状态，再次尝试退出");
                        // 如果仍在全屏状态，再次尝试退出
                        this.forceExitFullscreen().then(() => {
                            setTimeout(() => {
                                const stillFullscreen = !!(
                                    document.fullscreenElement ||
                                    document.webkitFullscreenElement ||
                                    document.mozFullScreenElement ||
                                    document.msFullscreenElement
                                );
                                if (!stillFullscreen) {
                                    resolve();
                                } else {
                                    // 如果还是全屏，直接resolve不阻塞流程
                                    console.log("无法退出全屏，强制继续流程");
                                    resolve();
                                }
                            }, 100);
                        });
                    }
                };

                // 立即检查一次
                checkFullscreen();
            });
        },

        // 退出全屏
        exitFullscreen() {
            return new Promise((resolve) => {
                if (document.exitFullscreen) {
                    document.exitFullscreen().then(resolve).catch(resolve);
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen().then(resolve).catch(resolve);
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen().then(resolve).catch(resolve);
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen().then(resolve).catch(resolve);
                } else {
                    resolve(); // 如果没有全屏API，直接resolve
                }
            });
        },

        // 处理返回全屏事件（从examExistPrompty触发）
        handleReturnFullscreen() {
            this.enterFullscreen();
            this.$refs.examExistPrompty.examExistPromptyShow = false;
        },

        // 处理考试开始事件
        handleExamStarted() {
            this.isBegin = true;
            this.exitFullscreenCount = 0; // 重置计数器
            this.isSubmitting = false; // 重置提交状态
            console.log('考试开始，开始监控切屏行为');

            this.timerInterval = setInterval(() => {
                this.countDown--;
                // 考试时间到清除定时器
                if (this.countDown <= 0) {
                    if (this.timerInterval) {
                        clearInterval(this.timerInterval);
                        this.timerInterval = "";
                    }
                }
            }, 1000);

            // 确保进入全屏
            this.$nextTick(() => {
                setTimeout(() => {
                    this.enterFullscreen();
                }, 500);
            });
        },

        // 刷新测试组件
        refreshTextExam() {
            this.refreshKey += 1;
        }
    }
};
</script>

<style lang="scss" scoped>
.exam_paper {
    width: 100%;
    min-height: 100vh;
    background: rgba(0, 0, 0, 0.06);

    .exam_paper_top {
        background: #FFFFFF;

        .top_content {
            width: $pageMainWidth;
            height: 60px;

            .exam_name {
                font-size: 18px;
                color: #111111;
            }

            :deep(.el-progress__text) {
                min-width: 0;
            }
        }
    }

    .exam_content {
        .exam_content_box {
            width: $pageMainWidth;
        }

        .test_paper_practice {
            width: 850px;
            background: #fff;
            padding: 20px;
            box-sizing: border-box;
            border-radius: 10px;
            .back_box{
                float: right;
            }

            .back_icon {
                width: 28px;
                height: 28px;
            }
        }
    }
}
</style>